<template>
  <div style="margin: 20px 15px 20px 15px; padding: 30px 25px 30px 25px; background-color: white">
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="对冲产品:">
        <el-select v-model="hedgeProductType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标类型:">
        <el-select v-model="hedgeTargetType" placeholder="请选择对冲目标类型">
          <el-option v-for="item in hedgeTargetTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标值:">
        <el-input v-model="hedgeTargetValue" placeholder="请输入对冲目标值"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="querySrcRecords">查询</el-button>
      </el-form-item>
    </el-form>

    <el-row><el-col :span="24"><div class="grid-content bg-purple-light"></div></el-col></el-row>
    <br><br>

    <el-form :inline="true">
      <el-form-item label="合并订单ID">
        <el-input v-model="batchOrderID" placeholder="请输入订单ID查询" style="width:600px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="querySrcRecordById">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="top" v-if="isShow">
      <div style="text-align:left">
        <el-select v-model="statusCode" placeholder="请选择目标状态">
          <el-option v-for="item in statusCodeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
        <el-button type="primary" plain @click="batchUpdateStatus">批量更新手动对冲记录</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange" v-loading="loading">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column fixed prop="id" label="ID" sortable width="70"></el-table-column>
        <el-table-column prop="pair" label="交易对" sortable width="80"></el-table-column>
        <el-table-column prop="plainUserId" label="用户ID" sortable width="130"></el-table-column>
        <el-table-column prop="api" label="API下单" sortable width="60"></el-table-column>
        <el-table-column prop="dealId" label="交易ID"  sortable width="130"></el-table-column>
        <el-table-column prop="platformOrderDirection"  sortable label="平台订单方向" width="60"></el-table-column>
        <el-table-column prop="price" label="原始价格" sortable width="80"></el-table-column>
        <el-table-column prop="dealAmount" label="成交数量" sortable width="80"></el-table-column>
        <el-table-column prop="statusCode" label="状态" sortable width="120"></el-table-column>
        <el-table-column prop="batchHedgeOrderId" label="合并对冲订单ID" sortable width="130"></el-table-column>
        <el-table-column prop="matchedHedgeProductType" label="对冲产品类型" sortable width="100"></el-table-column>
        <el-table-column prop="matchedHedgeTargetType" label="对冲目标类型" sortable width="120"></el-table-column>
        <el-table-column prop="matchedHedgeTargetValue" label="对冲目标值" sortable width="120"></el-table-column>
        <el-table-column prop="hedgeStartTime" label="对冲开始时间" sortable width="90"></el-table-column>
        <el-table-column prop="hedgeConfirmedTime" label="对冲确认成功时间" sortable width="90"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" sortable width="90"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" sortable width="90"></el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next, jumper"
                     :page-size="pageSize"
                     :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                     :total="total"
                     :current-page="currentPageNum"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
      <div style="text-align:right">
        <el-button type="success" plain @click="exportExcel()">全量导出excel</el-button>
        <el-button type="success" plain @click="exportCurrentData2Excel()">当前页导出excel</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import utils from './utils';
import './store';
import '@/entries/Machine/cache'
import {mapActions, mapState} from "vuex";

const statusCodeOption = [
  {key:'GIVEUP_AMT', label:'GIVEUP_AMT'},
  {key:'NOT_HEDGED', label:'NOT_HEDGED'},
  {key:'GIVEUP_USERID', label:'GIVEUP_USERID'},
  {key:'AUTO_HEDGED_SUCC', label:'AUTO_HEDGED_SUCC'},
  {key:'MANUAL_HEDGED_SUCC', label:'MANUAL_HEDGED_SUCC'},
  {key:'GIVEUP_NO_STRATEGY', label:'GIVEUP_NO_STRATEGY'},
  {key:'TRIED_HEDGED_NOT_CONFIRMED', label:'TRIED_HEDGED_NOT_CONFIRMED'},
  {key:'HEDGE_TRIED_FAIL_CAN_RETRY', label:'HEDGE_TRIED_FAIL_CAN_RETRY'},
  {key:'HEDGED_CANCELED_CANNOT_RETRY', label:'HEDGED_CANCELED_CANNOT_RETRY'},
  {key:'HEDGE_TRIED_FAIL_CANNOT_RETRY', label:'HEDGE_TRIED_FAIL_CANNOT_RETRY'}
]
const hedgeTargetTypeEnum_SPOT_Op = [
  {key:'', label:''},
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeEnum_SUPER_CONTRACT_Op = [
  {key:'', label:''},
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const columns = [
  {title:'ID',key:'id'},
  {title:'交易对',key:'pair'},
  {title:'用户ID',key:'plainUserId'},
  {title:'API下单',key:'api'},
  {title:'交易ID',key:'dealId'},
  {title:'平台订单方向',key:'platformOrderDirection'},
  {title:'原始价格',key:'price'},
  {title:'成交数量',key:'dealAmount'},
  {title:'状态',key:'statusCode'},
  {title:'合并对冲订单ID',key:'batchHedgeOrderId'},
  {title:'对冲产品类型',key:'matchedHedgeProductType'},
  {title:'对冲目标类型',key:'matchedHedgeTargetType'},
  {title:'对冲目标类型',key:'matchedHedgeTargetValue'},
  {title:'对冲开始时间',key:'hedgeStartTime'},
  {title:'对冲确认成功时间',key:'hedgeConfirmedTime'},
  {title:'创建时间',key:'createdTime'},
  {title:'更新时间',key:'updateTime'},
]

export default {
  name: "ResourceRecords",
  data() {
    return {
      pages:0,
      total:'',
      loading:false,
      coins:'',
      currentPageNum:1,
      pageSize:20,
      isShow:false,
      batchOrderID:'',
      dateRange:'',
      dateRange1:'',
      statusCode:'',
      tmpData: {},
      tableData:[],
      formData:{},
      buffer:'',
      multipleSelection: [],
      hedgeProductType:'',
      hedgeTargetType:'',
      hedgeTargetValue:'',
      hedgeActionType:'',
      columns:columns,
      statusCodeEnum:statusCodeOption,
      hedgeTargetTypeEnum:'',
      hedgeTargetTypeEnum_SPOT:hedgeTargetTypeEnum_SPOT_Op,
      hedgeTargetTypeEnum_SUPER_CONTRACT:hedgeTargetTypeEnum_SUPER_CONTRACT_Op,
    }
  },
  computed: {
    ...mapState('newHedgeStore', ['hedgeProductTypeOptions','pickerOptions']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        pageNum:this.currentPageNum,
        pageSize:this.pageSize
      };
    },
    paramsBak() {
      return {
        dateRange:this.dateRange,
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
      };
    },
  },
  created() {
    this.hedgeProductType = this.hedgeProductTypeOptions[0].key;
  },
  watch:{
    hedgeProductType(val){
      if (val === "SPOT"){
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SPOT
      }else{
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SUPER_CONTRACT
      }
    },
  },
  methods: {
    batchUpdateStatus(){
      let srcRecordIds = []
      let batchOrderId = ''
      for(let i in this.multipleSelection){
        srcRecordIds.push(this.multipleSelection[i].id)
        batchOrderId = this.multipleSelection[i].batchHedgeOrderId
      }
      srcRecordIds = utils.unique(srcRecordIds)
      if(!srcRecordIds){
        this.$message.error("请勾选手动对冲记录")
      }
      let params = {
        "srcRecordIds":srcRecordIds.join(","),
        "statusCode":this.statusCode,
        "batchOrderId":batchOrderId
      }
      utils.batchMarkSrcRecordHedgeStatus(params).then((response)=>{
        if(response.data === true){
          this.$message.success("批量更新手动对冲记录成功")
        }else{
          this.$message.error("批量更新手动对冲记录失败")
        }
      })
    },

    querySrcRecords(){
      if (!this.dateRange){
        this.$message({showClose: true, message: '请选择日期', type: 'error'})
        return
      }
      if (new Date(this.dateRange[0]).getTime() > new Date().getTime()){
        this.$message({showClose: true, message: '时间选择错误，起止时间不合理', type: 'error'});
        return
      }
      if (this.buffer === ''){
        this.buffer = this.paramsBak
      } else {
        if (this.buffer !== this.paramsBak){
          this.params.pageNum = 1
          this.buffer = this.paramsBak
        }
      }

      utils.queryStrategySrcRecords(this.params).then((response)=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].hedgeConfirmedTime = utils.getLocalTime(tableData[key].hedgeConfirmedTime)
          tableData[key].hedgeStartTime = utils.getLocalTime(tableData[key].hedgeStartTime)
        }
        this.tableData = tableData
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val){
      this.params.pageSize = val
      this.querySrcRecords()
    },
    handleCurrentChange(val) {
      this.params.pageNum = val
      this.querySrcRecords()
    },
    querySrcRecordById(){
      let formData = {}
      formData.batchOrderId = this.batchOrderID
      utils.pageQuerySrcRecordsByBatchOrderId(formData).then((response)=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].hedgeConfirmedTime = utils.getLocalTime(tableData[key].hedgeConfirmedTime)
          tableData[key].hedgeStartTime = utils.getLocalTime(tableData[key].hedgeStartTime)
        }
        this.tableData = tableData
      })
    },

    exportCurrentData2Excel(){
      let title = '原始对冲记录报表'
      let records = this.tableData
      for (let key in records){
        records[key].startHedgeTime = utils.getLocalTime(records[key].startHedgeTime)
        records[key].updateTime = utils.getLocalTime(records[key].updateTime)
        records[key].createdTime = utils.getLocalTime(records[key].createdTime)
        records[key].exchangeTime = utils.getLocalTime(records[key].exchangeTime)
      }
      utils.export2Excel(this.columns, records, title)
    },

    async exportExcel(){
      this.loading = true
      utils.queryAllStrategySrcRecords(this.params).then((response)=>{
        let tableData = response.data
        for (let key in tableData){
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].hedgeConfirmedTime = utils.getLocalTime(tableData[key].hedgeConfirmedTime)
          tableData[key].hedgeStartTime = utils.getLocalTime(tableData[key].hedgeStartTime)
        }
        let startTime = utils.getLocalTime(this.dateRange[0])
        let endTime = utils.getLocalTime(this.dateRange[1])
        let title = '对冲原始记录报表' + startTime + '-' + endTime
        utils.export2Excel(this.columns, tableData, title)
        this.loading = false
      })
    },
  },
}

</script>

<style scoped>
.block{
  background-color: white;
  margin: 10px 15px 10px 15px;
  padding: 10px 5px 10px 5px;
  height: auto;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
